<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import image1 from './images/image1.png';
	import image2 from './images/image2.png';
	import image3 from './images/image3.png';
	import image4 from './images/image4.png';
	import image5 from './images/image5.png';
	import image6 from './images/image6.png';
	import image7 from './images/image7.png';

	let slideshow = [
		{
			title: 'Barfield Hotel, Amarillo, TX',
			body: 'Soundproofing street noise and nightlife.',
			src: image1,
		},
		{
			title: 'Residence Inn Midtown Peachtree, Atlanta, GA',
			body: 'Energy efficiency, occupant comfort & aesthetics.',
			src: image2,
		},
		{
			title: 'Grand Bohemian, Charlotte, NC',
			body: 'Soundproofing street and nightlife noise.',
			src: image3,
		},
		{
			title: 'Hotel Grand Stark, Portland, OR',
			body: 'Soundproofing street and construction noise.',
			src: image4,
		},
		{
			title: 'AC Hotel, Houston, TX',
			body: 'Soundproofing light rail, traffic, & construction noise.',
			src: image5,
		},
		{
			title: 'Houston West Loop Marriott, Houston, TX',
			body: 'Soundproofing atrium noise.',
			src: image6,
		},
		{
			title: 'Cohen Federal Building, Washington, DC',
			body: 'Energy savings, occupant comfort.',
			src: image7,
		},
	];
</script>

<div class="relative mb-12 h-[300px] w-full overflow-hidden">
	<!-- eslint-disable-next-line better-tailwindcss/no-unknown-classes -->
	<ul class="animate-scroll flex w-max gap-8">
		{#each [0, 1] as n, i (i)}
			{#each slideshow as { src, title, body }, s (s)}
				<li class="relative h-[300px] flex-none list-none" id={n}>
					<Image {src} class="z-10 h-full w-auto object-cover" />
					<p
						class="
        absolute inset-x-0 bottom-0 z-20 bg-black/40 p-2 pl-3 text-xs/4.5
        text-white
      "
					>
						<strong>{title}</strong>
						<br />
						{body}
					</p>
				</li>
			{/each}
		{/each}
	</ul>
</div>

<style>
	@keyframes scroll {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-50%);
		}
	}

	.animate-scroll {
		animation: scroll 120s linear infinite;
	}
</style>
